import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="font-heading text-xl font-bold text-background-50 mb-4 tracking-wider">
              BB<span className="text-primary-400">体育</span>
            </h4>
            <p className="text-foreground-300 text-sm leading-relaxed">
              BB体育是您首选的专业体育服务平台，涵盖多项热门赛事、实时数据、精彩赛事直播与深度体育资讯。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">热门赛事</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-foreground-300 text-sm hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors cursor-pointer">联系我们</Link>
              </li>
              <li>
                <a href="#" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors cursor-pointer">用户协议</a>
              </li>
              <li>
                <a href="#" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">联系方式</h4>
            <ul className="space-y-2.5 text-sm text-foreground-300">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-primary-400"></i>
                <span>service@bbtiyu.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-customer-service-2-line mt-0.5 text-primary-400"></i>
                <span>在线客服 7×24小时</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-primary-400"></i>
                <span>服务覆盖全球多个国家和地区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-400 text-xs">
            &copy; 2026 BB体育官方平台 版权所有
          </p>
          <p className="text-foreground-500 text-xs">
            理性对待体育赛事，享受健康生活
          </p>
        </div>
      </div>
    </footer>
  );
}